import React, { useEffect } from "react";

import About_Banner from "./about-banner/About_Banner";
import Vision_Mission_Value from "./vision-mission-value/Vision_Mission_Value";
import Why_Choose_Us from "./why_choose_us/Why_Choose_Us";
import Man_Behind_The_Power from "./man_behind_the_power/Man_Behind_The_Power";
import PeopleBehindWork from "./people-behind-work/People_Behind_Work";
import Free_Consultation from "../home/free-consultation/Free_Consultation";
import WhatMakesHindustanDifferent from "./what-makes-hindustan-solar-different/What_Makes_Hindustan_Different";
import What_Customer_Say from "../home/what-customer-say/What_Customer_Say";
import Get_enquiry from "../home/get_enquiry/Get_enquiry";
import About_journey from "./About_journey/About_journey";

const About_Us = () => {

 

  return (
    <>
      <div >
        <About_Banner />
      </div>

      <div>
        <About_journey/>
      </div>

      <div >
        <Vision_Mission_Value />
      </div>

      <div >
        <Why_Choose_Us />
      </div>

      <div >
        <Get_enquiry />
      </div>

      <div >
        <Man_Behind_The_Power />
      </div>

      <div >
        <Free_Consultation />
      </div>

      <div >
        <PeopleBehindWork />
      </div>

      <div className="mb-5">
        <WhatMakesHindustanDifferent />
      </div>

      <div >
        {/* <What_Customer_Say /> */}
      </div>
    </>
  );
};

export default About_Us;